import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Signup.css';
import iconBack from '../../assets/images/icon-back.svg';
import genderMale from '../../assets/images/gender-male.svg';
import genderFemale from '../../assets/images/gender-female.svg';

interface LocationState {
  snsType?: string;
  snsId?: string;
  email?: string;
  name?: string;
  phone?: string;
  carrier?: string;
}

const Gender: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as LocationState;
  const [gender, setGender] = useState<'male' | 'female' | null>(null);

  const handleNext = () => {
    if (gender) {
      navigate('/signup/age', {
        state: {
          ...state,
          gender
        }
      });
    }
  };

  const handleSkip = () => {
    navigate('/signup/age', { state });
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="signup-container">
      <div className="signup-header">
        <button className="back-button" onClick={handleBack}>
          <img src={iconBack} alt="뒤로가기" />
        </button>
      </div>

      <div className="signup-content">
        <div className="signup-inner">
          <div className="signup-form">
            <div className="signup-title-section">
              <h1 className="signup-title">
                본인의 성별을
                <br />
                선택해 주세요.
              </h1>
            </div>

            <div className="gender-buttons">
              <button
                className={`gender-btn ${gender === 'male' ? 'selected' : ''}`}
                onClick={() => setGender('male')}
              >
                <img src={genderMale} alt="남성" />
                <span>남성</span>
              </button>
              <button
                className={`gender-btn ${gender === 'female' ? 'selected' : ''}`}
                onClick={() => setGender('female')}
              >
                <img src={genderFemale} alt="여성" />
                <span>여성</span>
              </button>
            </div>
          </div>

          <div className="signup-footer">
            <div className="spacer"></div>
            <button
              className={`signup-btn ${gender ? 'active' : ''}`}
              onClick={handleNext}
              disabled={!gender}
            >
              다음
            </button>
            <button className="skip-btn" onClick={handleSkip}>
              건너뛰기
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Gender;
